(function () {
  'use strict';

  var AUTOPLAY_MS = 6000;

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function initSlider(root) {
    var slides = qsa('[data-hero-slide]', root);
    var dotsRoot = root.parentElement.querySelector('[data-hero-dots]');
    var dots = dotsRoot ? qsa('[data-hero-dot]', dotsRoot) : [];
    if (slides.length < 2) return;

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
        dots[current].tabIndex = -1;
      }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
        dots[current].tabIndex = 0;
      }
    }

    function next() { goTo(current + 1); }

    function startAutoplay() {
      if (prefersReducedMotion) return;
      stopAutoplay();
      timer = setInterval(next, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
      dot.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var nextIndex = e.key === 'ArrowRight' ? current + 1 : current - 1;
        goTo(nextIndex);
        startAutoplay();
        dots[current].focus();
      });
    });

    startAutoplay();
  }

  qsa('[data-hero-slides]').forEach(initSlider);
})();
